import * as PartnersRepository from '@/api/partners';
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    partners: null,
    partnersById: {},
  },
  getters: {
    getPartnerById: (state) => (id) => state.partnersById[id],
  },
  actions: {
    ACT_FETCH_PARTNERS: async ({ dispatch, commit }) => {
      dispatch('wait/start', 'fetch.partners', { root: true });
      try {
        const response = await PartnersRepository.getList();
        const data = response?.data ?? [];
        commit('SET_PARTNERS', data);
      } finally {
        dispatch('wait/end', 'fetch.partners', { root: true });
      }
    },
    ACT_FETCH_PARTNER_BY_ID: async ({ dispatch, commit }, id) => {
      dispatch('wait/start', `fetch.partners.${id}`, { root: true });
      try {
        const response = await PartnersRepository.getById(id);
        const data = response?.data ?? [];
        commit('SET_PARTNER_BY_ID', { id, payload: data });
      } finally {
        dispatch('wait/end', `fetch.partners.${id}`, { root: true });
      }
    },
  },
  mutations: {
    SET_PARTNERS(state, payload) {
      Vue.set(state, 'partners', payload);
    },
    SET_PARTNER_BY_ID(state, { id, payload }) {
      Vue.set(state.partnersById, id, payload);
    },
  },
};
